import React, { useEffect } from 'react'
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { sendOTPFrgtPassword, vrfyAccts } from '../../../State/Auth/Action';
import { useNavigate } from 'react-router-dom';
//import { useContext } from "react";
//import { RecoveryContext } from "../App";

const OTPInput = () => {
    //const { email, otp, setPage } = useContext(RecoveryContext);
    const [timerCount, setTimer] = React.useState(60);
    const [OTPinput, setOTPinput] = useState(['','','','','','']);
    const [OTPinput2, setOTPinput2] = useState([0, 0, 0, 0, 0 ,0]);
    const [disable, setDisable] = useState(true);
    const navigate = useNavigate();
    const [emailOTP, setEmailOTP] = useState(null);
    const [mobileOTP, setMobileOTP] = useState();
    const [otpdata, setOtpdata] = useState({
      emailid:"",
      strotp:"",
      numotp:""
    })
    const dispatch = useDispatch();
    const {auth}=useSelector(store=>store);

    function resendOTP() {
        const data={
          reqJWT: auth?.jwt?.access_token
        }
        dispatch(sendOTPFrgtPassword(data)).then(() => setDisable(true))
        .then(() => alert("A new OTP has succesfully been sent to your email."))
        .then(() => setTimer(60)).catch(console.log);
        /*if (disable) return;
        axios
        .post("http://localhost:5000/send_recovery_email", {
            OTP: otp,
            recipient_email: email,
        })
        .then(() => setDisable(true))
        .then(() => alert("A new OTP has succesfully been sent to your email."))
        .then(() => setTimer(60))
        .catch(console.log);*/
    }

    function verfiyOTP() {
        //console.log(emailOTP)
        //console.log(mobileOTP)
        const data={
          otpdata,
          reqJWT: auth?.jwt?.access_token,
        }
        //console.log(data);
        dispatch(vrfyAccts(data)).then(()=>{
          //console.log(auth?.vrfyOTP);
        });
        {/*if (parseInt(OTPinput.join("")) === emailOTP) {
          //setPage("reset");
          return;
        }
          alert(
          "The code you have entered is not correct, try again or re-send the link"
        );
        return;*/}
    }

    useEffect(()=>{
        setEmailOTP(OTPinput.join(""));
        setMobileOTP(parseInt(OTPinput2.join("")));
        setOtpdata(()=>({
          emailid:localStorage.getItem("emailid"),
          strotp:emailOTP,
          numotp:mobileOTP
        }))
    });
    
    useEffect(()=>{
      if(auth?.vrfyOTP==='Success'){
        navigate("/reseted")
      }else if(auth?.vrfyOTP==='Wrong OTP'){
        alert("The code you have entered is not correct, try again or re-send the link");
      }
    },[auth?.vrfyOTP])
   {/* useEffect(()=>{
      const data={
        reqJWT: auth?.jwt?.access_token
      }
      dispatch(sendOTPFrgtPassword(data));
    },[auth?.jwt?.access_token]);*/}

    React.useEffect(() => {
        let interval = setInterval(() => {
        setTimer((lastTimerCount) => {
            lastTimerCount <= 1 && clearInterval(interval);
            if (lastTimerCount <= 1) setDisable(false);
            if (lastTimerCount <= 0) return lastTimerCount;
            return lastTimerCount - 1;
        });
        }, 1000); //each count lasts for a second
        //cleanup the interval on complete
        return () => clearInterval(interval);
    }, [disable]);
    
  return (
    <div className="flex justify-center items-center w-screen bg-gray-50">
      <div className="bg-white px-6 pt-10 pb-9 shadow-xl mx-auto w-full max-w-lg rounded-2xl">
        <div className="mx-auto flex w-full max-w-md flex-col space-y-16">
          <div className="flex flex-col items-center justify-center text-center space-y-2">
            <div className="font-semibold text-3xl">
              <p>Email Verification</p>
            </div>
            <div className="flex flex-row text-sm font-medium text-gray-400">
              <p>We have sent a code to your email </p>
            </div>
          </div>

          <div>
            <form>
              <div className="flex flex-col space-y-16">
                <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xl">
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          e.target.value,
                          OTPinput[1],
                          OTPinput[2],
                          OTPinput[3],
                          OTPinput[4],
                          OTPinput[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          e.target.value,
                          OTPinput[2],
                          OTPinput[3],
                          OTPinput[4],
                          OTPinput[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          OTPinput[1],
                          e.target.value,
                          OTPinput[3],
                          OTPinput[4],
                          OTPinput[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          OTPinput[1],
                          OTPinput[2],
                          e.target.value,
                          OTPinput[4],
                          OTPinput[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          OTPinput[1],
                          OTPinput[2],
                          OTPinput[3],
                          e.target.value,
                          OTPinput[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput([
                          OTPinput[0],
                          OTPinput[1],
                          OTPinput[2],
                          OTPinput[3],
                          OTPinput[4],
                          e.target.value
                        ])
                      }
                    ></input>
                  </div>
                </div>
                
                <div className="flex flex-col items-center justify-center text-center space-y-2">
                  <div className="font-semibold text-3xl">
                    <p>Mobile Verification</p>
                  </div>
                  <div className="flex flex-row text-sm font-medium text-gray-400">
                    <p>We have sent a code to your mobile number </p>
                  </div>
                </div>
                <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xl">
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput2([
                          e.target.value,
                          OTPinput2[1],
                          OTPinput2[2],
                          OTPinput2[3],
                          OTPinput2[4],
                          OTPinput2[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput2([
                          OTPinput2[0],
                          e.target.value,
                          OTPinput2[2],
                          OTPinput2[3],
                          OTPinput2[4],
                          OTPinput2[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput2([
                          OTPinput2[0],
                          OTPinput2[1],
                          e.target.value,
                          OTPinput2[3],
                          OTPinput2[4],
                          OTPinput2[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput2([
                          OTPinput2[0],
                          OTPinput2[1],
                          OTPinput2[2],
                          e.target.value,
                          OTPinput2[4],
                          OTPinput2[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput2([
                          OTPinput2[0],
                          OTPinput2[1],
                          OTPinput2[2],
                          OTPinput2[3],
                          e.target.value,
                          OTPinput2[5]
                        ])
                      }
                    ></input>
                  </div>
                  <div className="w-16 h-16 mr-2">
                    <input
                      maxLength="1"
                      className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                      type="text"
                      name=""
                      id=""
                      onChange={(e) =>
                        setOTPinput2([
                          OTPinput2[0],
                          OTPinput2[1],
                          OTPinput2[2],
                          OTPinput2[3],
                          OTPinput2[4],
                          e.target.value
                        ])
                      }
                    ></input>
                  </div>
                </div>

                <div className="flex flex-col space-y-5">
                  <div>
                    <a
                      onClick={() => verfiyOTP()}
                      className="flex flex-row cursor-pointer items-center justify-center text-center w-full border rounded-xl outline-none py-5 bg-blue-700 border-none text-white text-sm shadow-sm"
                    >
                      Verify Account
                    </a>
                  </div>

                  <div className="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-gray-500">
                    <p>Didn't recieve code?</p>{" "}
                    <a
                      className="flex flex-row items-center"
                      style={{
                        color: disable ? "gray" : "blue",
                        cursor: disable ? "none" : "pointer",
                        textDecorationLine: disable ? "none" : "underline",
                      }}
                      onClick={() => resendOTP()}
                    >
                      {disable ? `Resend OTP in ${timerCount}s` : "Resend OTP"}
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OTPInput
